import React, { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import Modal from 'components/Common/Modal/Modal';
import ColissimoPlugin, {
  RefType as ColissimoRefType,
} from 'components/Checkout/Shipping/ColissimoPlugin/ColissimoPlugin';
import useEnv from 'hooks/useEnv';
import useJQuery from 'hooks/useJQuery';
import { RelayPoint } from 'types/Cart';

import styles from './ModalColissimo.module.scss';

function ModalColissimo({
  closeModal,
  onSelect,
  widgetReady,
  isOpen,
}: {
  onSelect: (objet: RelayPoint) => void;
  widgetReady: () => void;
  closeModal: () => void;
  isOpen: boolean;
  privilegeCodeContent?: string;
}): JSX.Element | null {
  const { t } = useTranslation();
  const { datetimeApp } = useEnv();
  const colissimoRef = useRef<ColissimoRefType>(null);
  const { isLoaded: isJqueryImported } = useJQuery();
  const [isMapboxImported, setMapboxImported] = useState(false);

  function closeModalHandler() {
    closeModal();
    colissimoRef.current && colissimoRef.current.closeColissimo();
  }

  useEffect(() => {
    if (!document.getElementById('colissimo-mabbox')) {
      const mapboxGlScript = document.createElement('script');
      mapboxGlScript.src =
        'https://api.mapbox.com/mapbox-gl-js/v2.6.1/mapbox-gl.js';
      mapboxGlScript.id = 'colissimo-mabbox';
      document.body.appendChild(mapboxGlScript);
      mapboxGlScript.addEventListener('load', () => {
        setMapboxImported(true);
      });
    } else {
      setMapboxImported(true);
    }
  }, []);

  useEffect(() => {
    if (isJqueryImported && isMapboxImported) {
      if (!document.getElementById('colissimo-js')) {
        const version = datetimeApp ? `?${datetimeApp}` : '';
        const colissimoScript = document.createElement('script');
        colissimoScript.src = `${process.env.PUBLIC_URL}/fr/colissimo/js/jquery.plugin.colissimo.js${version}`;
        colissimoScript.id = 'colissimo-js';

        document.body.appendChild(colissimoScript);
        colissimoScript.addEventListener('load', () => {
          widgetReady();
        });
      } else {
        widgetReady();
      }
    }
  }, [isJqueryImported, isMapboxImported]);

  return (
    <>
      <Helmet>
        <link
          rel="stylesheet"
          type="text/css"
          href="https://api.mapbox.com/mapbox-gl-js/v2.6.1/mapbox-gl.css"
        />
      </Helmet>
      <Modal isOpen={isOpen} modalClassName={styles.modalColissimo}>
        <div className={styles.body}>
          <ColissimoPlugin
            onSelect={onSelect}
            ref={colissimoRef}
            onClose={closeModal}
            classes={{ container: styles.colissimoContainer }}
          />
        </div>
        <div className={styles.footer}>
          <button onClick={closeModalHandler}>{t('LABEL_CLOSE')}</button>
        </div>
      </Modal>
    </>
  );
}

export default ModalColissimo;
